var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18H1C0.450001 18 0 17.55 0 17C0 16.45 0.450001 16 1 16H17C17.55 16 18 16.45 18 17C18 17.55 17.55 18 17 18ZM17 10H1C0.450001 10 0 9.55 0 9C0 8.45 0.450001 8 1 8H17C17.55 8 18 8.45 18 9C18 9.55 17.55 10 17 10ZM18 1C18 1.55 17.55 2 17 2H1C0.450001 2 0 1.55 0 1C0 0.45 0.450001 0 1 0H17C17.55 0 18 0.45 18 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14H14C14.55 14 15 13.55 15 13C15 12.45 14.55 12 14 12H4C3.45 12 3 12.45 3 13C3 13.55 3.45 14 4 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6H14C14.55 6 15 5.55 15 5C15 4.45 14.55 4 14 4H4C3.45 4 3 4.45 3 5C3 5.55 3.45 6 4 6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignCenter);
export default __webpack_public_path__ + "static/media/TextAlignCenter.57a58f9aeba8230dcbb48ab51b842dd1.svg";
export { ForwardRef as ReactComponent };